/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { BaseModal, Button, Input, Textarea } from '@cokitchen/cokitchen-components';
import { ReactComponent as ReasonIcon } from '../../assets/images/reason.svg';
import React, { FC, useState } from 'react';
import { SOLD_OUT_MINUTES, TURN_OFF_REASON } from '../../helpers/constants';

type Props = {
  show: boolean;
  onClose: () => void;
  name: string;
  brandName: string;
  workingHours: Array<{
    day: string;
    opening_time: string;
  }>;
  onConfirm: (data: { soldOutMinutes: number; reason: string[] }) => void;
  loading: boolean;
};

const TurnOffMeal: FC<Props> = ({ show, onClose, name, onConfirm, loading }: Props) => {
  const [soldOutMinutes, setSoldOutMinutes] = useState<number>(0);
  const [value, setValue] = useState<string[]>([]);
  const [comment, setComment] = useState<string>('');
  const isDisabled = value.length === 0;

  const submitData = () => {
    const finalReasons = value.map((reason) =>
      reason === 'Other' && comment.trim().length > 0 ? comment.trim() : reason
    );

    onConfirm({ soldOutMinutes, reason: finalReasons });
    onClose();
  };

  const toggleMinute = (minutes: number) => {
    if (minutes === soldOutMinutes) setSoldOutMinutes(0);
    else setSoldOutMinutes(minutes);
  };

  const handleChange = (reason: string) => {
    if (value.includes(reason)) {
      setValue(value.filter((r) => r !== reason));
    } else {
      setValue([...value, reason]);
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title={`Set ${name} to 'sold out'`}
      onRequestClose={onClose}
      titleIcon={<ReasonIcon />}
      titleIconColor='danger'
      footer={
        <div className='flex justify-end gap-x-4'>
          <Button
            color='gray'
            variant='block'
            onClick={onClose}
            className='!bg-[#F2F2F2] !text-[#595959] !border-0 !w-[100px]'>
            Cancel
          </Button>
          <Button
            color='primary'
            variant='block'
            onClick={submitData}
            className='!w-[100px]'
            loading={loading}
            disabled={isDisabled}>
            Turn off
          </Button>
        </div>
      }>
      <div className='pt-5'>
        <p className='text-[#595959] text-sm font-normal mb-4'>When will {name} be back?</p>
        <div className='grid grid-cols-3 gap-8 max-w-[420px] mt-5'>
          {SOLD_OUT_MINUTES.map((minute) => (
            <span
              key={minute}
              className={`border rounded-[8px] p-2 text-center ${
                soldOutMinutes === minute
                  ? 'bg-red-1 border-red-2 text-red-5'
                  : ' border-gray-2 text-gray-5'
              }`}
              role='button'
              onClick={() => toggleMinute(minute)}>
              {minute === 60 ? '+ 1 hr' : `+ ${minute} mins`}
            </span>
          ))}
        </div>
        <div className='mr-16'>
          <p className='mt-4 text-[#1A1A1A] text-sm font-normal'>
            Add reason why you’re making this category unavailable
          </p>
          <div
            id='reason-group'
            className='grid gap-x-11 gap-y-6 grid-cols-2 grid-rows-2 my-4 mr-12 mt-8 text-xs mx-2'>
            {TURN_OFF_REASON.map((reason, i) => (
              <Input
                key={i}
                value={reason}
                label={reason}
                type='checkbox'
                name='turn-off-reasons'
                onChange={() => handleChange(reason)}
                checked={value.includes(reason)}
              />
            ))}
          </div>

          {value.includes('Other') && (
            <div className='mt-2'>
              <Textarea
                maxLength={150}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder='Add a comment...'
                className='w-full text-[#A6A6A6]'
              />
              <span className='text-[#858585] text-xs'>Word limit: {comment.length}/150</span>
            </div>
          )}
        </div>
      </div>
    </BaseModal>
  );
};

export default TurnOffMeal;
